import React from "react";

const CouponStatusBadge = ({ status }) => {
    const getStatusClass = () => {
        switch (status?.toLowerCase()) {
            case "active":
                return "status-active";

            case "inactive":
                return "status-inactive";

            case "expired":
                return "status-expired";

            case "scheduled":
                return "status-scheduled";

            default:
                return "status-default";
        }
    };

    return (
        <span className={`coupon-status-badge ${getStatusClass()}`}>
            {status}
        </span>
    );
};

export default CouponStatusBadge;